<script setup lang="ts">
import { twMerge } from "tailwind-merge"

const props = defineProps<{ class?: string }>()
</script>

<template>
  <h2
    :class="
      twMerge('text-md leading-5 font-semibold text-zinc-800', props.class)
    "
  >
    <slot />
  </h2>
</template>
